export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'd56b2d63-8910-4507-8ec4-ac71909cc99a';
export const MODAL_CLOSE_TIMEOUT = 2.5;
